// Ordena as alternativas dentro de cada grupo
export const sortTableRow = (alternativas) => {
  return alternativas.sort((a, b) => {
    const tituloGradeA = a.titulo_grade?.toLowerCase();
    const tituloGradeB = b.titulo_grade?.toLowerCase();
    return tituloGradeA?.localeCompare(tituloGradeB);
  });
}; 